import { Fragment, useRef } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FileUpload } from 'app/domains/upload';
import { usePleditor, usePreview } from 'shared/domains/documents';
import { SupportedFileMimeTypes } from 'shared/domains/filesystem';
export function ImportDocumentButton(props) {
    const { disabled } = props;
    const { pleditorState, pleditor } = usePleditor();
    const { isFreeText, isPleditorImportExportAvailable } = usePreview();
    const inputRef = useRef(null);
    const isDisabled = disabled || pleditorState === 'initializing';
    const handleFileUpload = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleFileChange = (event) => {
        if (pleditor && event.target.files) {
            const file = event.target.files[0];
            pleditor.commands.execute('importWord', file, {});
        }
    };
    if (!isPleditorImportExportAvailable || !isFreeText) {
        return null;
    }
    return (<Fragment>
      <Button size="xs" appearance="secondary" onClick={handleFileUpload} disabled={isDisabled}>
        <Falcon icon="file-import"/>
        <Trans comment="Dropdown label for importing document">Import version</Trans>
      </Button>
      <FileUpload ref={inputRef} accept={[SupportedFileMimeTypes.DOCX]} onChange={handleFileChange}/>
    </Fragment>);
}
